import { ElementType } from 'react';
import { TextProps } from '@msc-b2c/interfaces/types';
import { sanitize, SanitizeConfig as Config } from '@msc-b2c/shared-utils';
import './text.module.scss';

export const Text = ({
  id,
  text,
  visible = true,
  styleOption = '',
  tagHtml = 'p',
  tabIndex,
  sanitizeConfig = {},
}: TextProps) => {
  const TextComponent: ElementType = tagHtml;
  const config = {
    ...sanitizeConfig,
    ADD_ATTR: ['target', ...(sanitizeConfig.ADD_ATTR || [])],
  };
  return (
    text && (
      <div
        id={id}
        className={`${styleOption} ${!visible ? '-not-visible' : ''}`}
      >
        <div
          className="cmp-text"
          {...(tabIndex !== undefined && { tabIndex })}
        >
          <TextComponent
            dangerouslySetInnerHTML={{ __html: sanitize(text, config) }}
          ></TextComponent>
        </div>
      </div>
    )
  );
};
